import script from "./PayinDetailsSettlementDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./PayinDetailsSettlementDialog.vue?vue&type=script&setup=true&lang=js"

import "./PayinDetailsSettlementDialog.vue?vue&type=style&index=0&id=47ba9c24&lang=postcss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-47ba9c24"]])

export default __exports__